import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { cars } from "../data/staticData";

const Gallery = () => {
  const [hoveredCar, setHoveredCar] = useState(null);

  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="gallery-page">
      {/* Hero */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 hero-gradient" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <motion.h1
            className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-black uppercase tracking-tighter mb-4 sm:mb-6 px-2"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-white">Nuestra </span>
            <span className="text-[#00A8FF] text-glow">Galería</span>
          </motion.h1>
          <motion.p
            className="text-white/60 text-sm sm:text-base lg:text-lg font-light max-w-2xl mx-auto px-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            Explora nuestras transformaciones más impresionantes. Cada vehículo
            cuenta una historia de renovación y excelencia.
          </motion.p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {cars.map((car, index) => (
              <Link to={`/galeria/${car.id}`} key={car.id} data-testid={`gallery-car-${car.id}`}>
                <motion.div
                  className="glass-card group cursor-pointer overflow-hidden relative"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                  whileHover={{ scale: 1.02 }}
                  onMouseEnter={() => setHoveredCar(car.id)}
                  onMouseLeave={() => setHoveredCar(null)}
                >
                  <div className="relative h-80 overflow-hidden">
                    {/* Main image (primera foto) */}
                    <motion.img
                      src={car.thumbnail}
                      alt={car.name}
                      className="w-full h-full object-cover"
                      animate={{
                        scale: hoveredCar === car.id ? 1.1 : 1,
                      }}
                      transition={{ duration: 0.5 }}
                    />

                    {/* Segunda imagen overlay on hover */}
                    {car.images?.length > 1 && (
                      <motion.div
                        className="absolute inset-0"
                        initial={{ clipPath: "inset(0 100% 0 0)" }}
                        animate={{
                          clipPath: hoveredCar === car.id ? "inset(0 50% 0 0)" : "inset(0 100% 0 0)",
                        }}
                        transition={{ duration: 0.5 }}
                      >
                        <img
                          src={car.images[1]}
                          alt={`${car.name} detalle`}
                          className="w-full h-full object-cover"
                        />
                      </motion.div>
                    )}

                    {/* Gradient overlays */}
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628] via-transparent to-transparent" />
                    
                    {/* Glow border on hover */}
                    <motion.div
                      className="absolute inset-0 border-2 border-[#00A8FF]"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: hoveredCar === car.id ? 0.5 : 0 }}
                      transition={{ duration: 0.3 }}
                    />
                  </div>

                  <div className="p-4 sm:p-6">
                    <h3 className="text-base sm:text-lg lg:text-xl font-bold text-white mb-2 group-hover:text-[#00A8FF] transition-colors">
                      {car.name}
                    </h3>
                    <p className="text-white/60 font-light text-xs sm:text-sm line-clamp-2">
                      {car.description}
                    </p>
                    <div className="mt-3 sm:mt-4 flex flex-wrap gap-1 sm:gap-2">
                      {car.services_applied?.slice(0, 3).map((service, i) => (
                        <span
                          key={i}
                          className="px-1.5 sm:px-2 py-0.5 sm:py-1 text-[10px] sm:text-xs glass text-[#00A8FF] uppercase tracking-wider"
                        >
                          {service}
                        </span>
                      ))}
                    </div>
                  </div>
                </motion.div>
              </Link>
            ))}
          </div>

          {cars.length === 0 && (
            <div className="text-center py-20">
              <p className="text-white/60 text-lg">No hay vehículos en la galería.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Gallery;
